import React from "react";


export const GamesSliderSettings = {
  dots: false,
  infinite: false,
  autoplay:false,
  slidesToShow:6.3,
  slidesToScroll: 2,
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,

  responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 5.4 } },
    { breakpoint: 1600, settings: { slidesToShow: 4.8 } },
    { breakpoint: 1400, settings: { slidesToShow: 3.9} },
    { breakpoint: 1200, settings: { slidesToShow: 3.5 } },
    { breakpoint: 991, settings: { slidesToShow: 3.1} },
    { breakpoint: 767, settings: { slidesToShow: 2.5 } },
    { breakpoint: 576, settings: { slidesToShow: 2.9,   centerMode: true,   autoplay: true,   autoplaySpeed: 2500,   centerMode: true, centerPadding: "0px" } },
    { breakpoint: 400, settings: { slidesToShow: 2.9,   centerMode: true,   autoplay: true,   autoplaySpeed: 2500,  centerMode: true, centerPadding: "0px" } },
  ],
};


const GamesCard = ({ item }) => {
  return (
    <div className="games-card-main">
      <div
        className="games-card battle-card"
        style={{
          background: item.bg,
          border: `1px solid ${item.border}`,
        }}
      >
        {item.image && (
          <img
            src={item.image}
            alt="battle"
            className="games-battle-image"
          />
        )}

        <div className="battle-title">
          {item.title}
        </div>
      </div>
    </div>
  );
};

export default GamesCard;